import { Injectable } from '@angular/core';
import { NotificationStackService } from 'app/layout/common/notification-stack/notification-stack.service';

@Injectable({
    providedIn: 'root'
})
export class NotificationSnackbarService {

    constructor(private notificationStackService: NotificationStackService) {}

    /**
     * Check for new unread notifications and display them
     */
    checkForNewNotifications(): void {
        this.notificationStackService.checkForNewNotifications();
    }

    /**
     * Initialize SignalR for real-time notification push
     */
    initializeSignalR(): void {
        this.notificationStackService.subscribeToSignalR();
    }
}
